export default __webpack_public_path__ + "/dist/images/connections-active.414c7fbfaf1a621b73f38b290079ac1b.svg";